/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

export type CreateOrUpdateTranslationInput = {
    component: string;
    language?: string | null | undefined;
    text?: string | null | undefined;
};
export type CreateOrUpdateTranslationMutationVariables = {
    input: CreateOrUpdateTranslationInput;
};
export type CreateOrUpdateTranslationMutationResponse = {
    readonly CreateOrUpdateTranslationMutation: boolean;
};
export type CreateOrUpdateTranslationMutation = {
    readonly response: CreateOrUpdateTranslationMutationResponse;
    readonly variables: CreateOrUpdateTranslationMutationVariables;
};



/*
mutation CreateOrUpdateTranslationMutation(
  $input: CreateOrUpdateTranslationInput!
) {
  CreateOrUpdateTranslationMutation(input: $input)
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "kind": "ScalarField",
    "name": "CreateOrUpdateTranslationMutation",
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "CreateOrUpdateTranslationMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "CreateOrUpdateTranslationMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "264e2f17ac6dd0b03aca153e229f0036",
    "id": null,
    "metadata": {},
    "name": "CreateOrUpdateTranslationMutation",
    "operationKind": "mutation",
    "text": "mutation CreateOrUpdateTranslationMutation(\n  $input: CreateOrUpdateTranslationInput!\n) {\n  CreateOrUpdateTranslationMutation(input: $input)\n}\n"
  }
};
})();
(node as any).hash = 'eaf3b5547b4604a2a59e5742d2abbbd2';
export default node;
